export default __webpack_public_path__ + "static/media/300x250-01.443dc813.gif";